module.exports = __webpack_public_path__ + "static/media/books2.4489e5f3.svg";